import React, { useState } from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaRoleBadge from "../../../../ui-kit/kuika-role-badge/kuika-role-badge";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

// The display names exactly as the backend seeds them.
const WORKSPACE_ROLES: string[] = [
  "Workspace Owner",
  "Member",
  "Supervisor",
  "Finance Manager",
  "DevOps",
  "Design Ops",
  "Component Developer",
  "Component Designer"
];
const PROJECT_ROLES: string[] = ["Project Owner", "Developer", "Designer", "Viewer"];

/** One user's role, changed in front of the viewer: the badge morphs instead of cutting. */
const RoleChangeDemo = (): JSX.Element => {
  const [index, setIndex] = useState<number>(0);
  const role: string = PROJECT_ROLES[index];

  return (
    <>
      <KuikaRoleBadge role={role} animateChanges />
      <KuikaButton type="tertiary" size="sm" onClick={(): void => setIndex((index + 1) % PROJECT_ROLES.length)}>
        Next role
      </KuikaButton>
    </>
  );
};

export const RoleBadgeStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Role Badge"
      componentName="KuikaRoleBadge"
      sourcePath="ui-kit/kuika-role-badge"
      description="A user's workspace or project role. Every role keeps one colour on every surface; families share a hue."
    >
      <SpecRow label="Workspace roles">
        {WORKSPACE_ROLES.map((role: string): JSX.Element => (
          <KuikaRoleBadge key={role} role={role} />
        ))}
      </SpecRow>
      <SpecRow label="Project roles">
        {PROJECT_ROLES.map((role: string): JSX.Element => (
          <KuikaRoleBadge key={role} role={role} />
        ))}
      </SpecRow>
      <SpecRow label="Unknown role" caption="Any name the map does not know is grey">
        <KuikaRoleBadge role="Full Access" />
      </SpecRow>
      <SpecRow label="Short label" caption="label changes the text, never the colour">
        <KuikaRoleBadge role="Workspace Owner" label="Owner" />
      </SpecRow>
      <SpecRow
        label="animateChanges"
        caption="the same user's role changing in place: the colour fades over, the name swaps, the width follows"
      >
        <RoleChangeDemo />
      </SpecRow>
      <SpecRow label="Picker trigger" caption="Wrapped in a button by the caller">
        <KuikaRoleBadge
          role="Developer"
          rightIcon={<KuikaSvg name="chevron-down" type="arrows" width={11} height={11} />}
        />
      </SpecRow>
    </ShowcaseFrame>
  );
};
